/** Tiny typed pub/sub for inter-module events. */

export type EventMap = {
  'auth:ready': { user_id: string; display_name: string }
  'spin:start': { client_request_id: string; bet: number }
  'spin:settled': { spin_id: string; total_win: number }
  'spin:error': { message: string }
  'wallet:changed': { balance: number }
}

type Handler<T> = (payload: T) => void

class EventBusImpl {
  private handlers = new Map<keyof EventMap, Set<Handler<unknown>>>()

  on<K extends keyof EventMap>(event: K, fn: Handler<EventMap[K]>): () => void {
    let set = this.handlers.get(event)
    if (!set) {
      set = new Set()
      this.handlers.set(event, set)
    }
    set.add(fn as Handler<unknown>)
    return () => set!.delete(fn as Handler<unknown>)
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]): void {
    const set = this.handlers.get(event)
    if (!set) return
    for (const fn of set) (fn as Handler<EventMap[K]>)(payload)
  }
}

export const EventBus = new EventBusImpl()
